module.exports = __webpack_public_path__ + "static/img/21.6e973bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/gwphoto/21.jpg
// module id = IInN
// module chunks = 1